angular.module('env.i18n.angularLocalization', ['tmh.dynamicLocale'])

    .config(function (tmhDynamicLocaleProvider) {
        tmhDynamicLocaleProvider.localeLocationPattern(
            om.config.debug
                ? 'bower_components/angular-i18n/angular-locale_{{locale | lowercase}}.js'
                : 'vendor/angular-i18n/angular-locale_{{locale | lowercase}}.js');
    })

    .service('angularLocalization', function ($q, $http, tmhDynamicLocale, EventingMixin, LocaleName) {
        var _this = this;
        _this = _.extend(_this, new EventingMixin(['changed']));

        /**
         * Cache of available languages
         * @type {Array}
         */
        var languagesList;

        /**
         * Default language
         * @type {string}
         */
        var defaultLanguage = "en-GB";

        /**
         * Current language
         * @type {string}
         */
        var currentLanguage;

        /**
         * Get list of supported angular languages
         * @returns {!Promise} promise
         */
        _this.getLanguagesList = function () {
            var deferred = $q.defer();
            if (languagesList) {
                deferred.resolve(languagesList);
            } else {
                $http.get('translations/availableAngularLocales.json')
                    .then(function (resp) {
                        try {
                            languagesList = resp.data;
                            deferred.resolve(languagesList);
                        } catch (err) {
                            languagesList = null;
                            deferred.reject(err);
                        }
                    }, function (err) {
                        deferred.reject(err);
                    });
            }

            return deferred.promise;
        };

        /**
         * Set current language for angular translations
         * @param {string} lang - code of the language
         * @returns {!Promise} promise
         */
        _this.setCurrentLanguage = function (lang) {
            var deferred = $q.defer();

            _this.getLanguagesList().then(
                function (langList) {
                    // get the most suitable language code
                    var languageCode = (new LocaleName(lang)).getMostSuitableLanguage(langList) || defaultLanguage;

                    tmhDynamicLocale.set(languageCode.toLowerCase()).then(
                        function () {
                            currentLanguage = languageCode;
                            _this.events.raise('changed', {language: languageCode});
                            deferred.resolve(languageCode);
                        },
                        function (err) {
                            deferred.reject(err);
                        });
                },
                function (err) {
                    deferred.reject(err);
                }
            );

            return deferred.promise;
        };

        /**
         * Get current angular localization language
         * @returns {string|undefined} current angular localization language code
         */
        _this.getCurrentLanguage = function () {
            return currentLanguage;
        };

        return _this;
    })

;